var _style, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1920 596.6",
    style: {
      enableBackground: "new 0 0 1920 596.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#F5F6FA;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 1920,
    height: 596.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "bg-city_kopia",
    className: "st1",
    d: "M0,596.6V488.3h16.6V363l33.6-13.7l21,14.7v69.3l18.9-7.4V231.7L191,206.5h69.3v-77.7 l78.8-29.4h14.7v-83h3.1v82.3l42.8,1.4v9.8l59.5,13.3v245.1h11.2V248.6l39.2-17.6l4.2-53.2l2.2,53.9l59.5,10.5v116.2l15.4-13.3 v-28.7l42-0.7v27.3l16.1,13.3V178.5h16.1v-68.6h25.2V53.2h24.5V26.6h14v-14L743.5,0l13.4,11.2v15.4h23.8v26.6h38.5v116.2h48.3v109.2 h10.5v-37.8h49.7l4.2-58.1l2.2,58.1h54.6v28.7h44.1v7h15.4l31.5-31.5v-69.3l23.1-32.2l4.9-16.1l3.5,16.1l32.9,30.8v137.9l30.1,30.1 h17.5l16.1-16.1v-91l56-84.7l2.2-41.3l4.9,39.2h7.7v212.1h16.8V55.3l189.1-22.4h69.3v135.8l52.5-35V105h21.7v27.3l77.7,48.3v44.8 h23.8v65.1h10.5v-11.9h51.8v11.9h23.1v177.1l20.3,16.9v36.4h16.8V394.2h30.8v-90.3h36.9v292.7H0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCity);
export default __webpack_public_path__ + "static/media/city.e3f1122ac4109ff2c5c5ebaacb9d1912.svg";
export { ForwardRef as ReactComponent };